import {AbstractEntity} from '../../../../../shared/entities/abstract/abstract.entity';

/**
 * Entity to be instantiated from the hub response
 * @class TemplateEntity
 */
export class TemplateEntity extends AbstractEntity {
  /**
   * Name of the template
   * @type {string}
   */
  private name: string;

  /**
   * Template content type
   */
  private contentType: string;

  /**
   * Gets the name
   * @returns {string}
   */
  getName(): string {
    return this.name;
  }

  /**
   * Sets the name
   * @param {string} value name value
   * @returns {void}
   */
  setName(value: string) {
    this.name = value;
  }

  /**
   * Gets the content type
   * @returns {string}
   */
  getContentType() {
    return this.contentType;
  }

  /**
   * Sets the content type
   * @param {string} value Value for the content type
   * @returns {TemplateEntity}
   */
  setContentType(value: string) {
    this.contentType = value;
    return this;
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/template-modal/entities/template.entity.ts